import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

import "./css/confirmacionSummary.css";
import CsHeader from "./confirmacion/CsHeader";
import TabPorTalento from "./confirmacion/TabPorTalento";
import TabPorPregunta from "./confirmacion/TabPorPregunta";
import {
  downloadConfirmacionPDF,
  previewConfirmacionPDF,
} from "../../../utils/generateConfirmacionPDF";
import PdfPreviewModal from "../../UI/PdfPreviewModal";

const TABS = [
  { key: "talento", label: "Por Talento", icon: "mdi:star-outline" },
  { key: "pregunta", label: "Por Pregunta", icon: "mdi:help-circle-outline" },
];

const ConfirmacionSummary = ({ summary }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("talento");
  const [pdfOpen, setPdfOpen] = useState(false);

  if (!summary || !summary.confirmaciones) return null;

  const hasPreguntaTab =
    Array.isArray(summary.pregunta_respuesta_agrupada) &&
    summary.pregunta_respuesta_agrupada.length > 0;

  return (
    <div className="row">
      <div className="col-12">
        {/* ── Banner de éxito ── */}
        <CsHeader count={summary.count} />

        {/* ── Botón de descarga PDF ── */}
        {hasPreguntaTab && (
          <motion.div
            className="cs-download-wrap mb-20"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            <button
              className="cs-download-pdf-btn"
              onClick={() => setPdfOpen(true)}
              type="button"
            >
              <Icon icon="mdi:file-pdf-box" className="text-xl" />
              <span>Descargar PDF</span>
              <Icon icon="mdi:download" className="text-lg" />
            </button>
          </motion.div>
        )}

        <PdfPreviewModal
          open={pdfOpen}
          onClose={() => setPdfOpen(false)}
          title="Vista previa · Mi Rol Vital"
          previewFn={previewConfirmacionPDF}
          downloadFn={downloadConfirmacionPDF}
          previewArgs={summary.pregunta_respuesta_agrupada}
        />

        {/* ── Tabs principales ── */}
        {hasPreguntaTab && (
          <motion.div
            className="cs-main-tabs-wrap mb-20"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.4 }}
          >
            {TABS.map((tab) => (
              <button
                key={tab.key}
                className={`cs-main-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
                type="button"
              >
                <Icon icon={tab.icon} />
                {tab.label}
              </button>
            ))}
          </motion.div>
        )}

        {/* ── Contenido del tab activo ── */}
        <AnimatePresence mode="wait">
          {activeTab === "talento" && (
            <motion.div
              key="tab-talento"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
            >
              <TabPorTalento confirmaciones={summary.confirmaciones} />
            </motion.div>
          )}

          {activeTab === "pregunta" && hasPreguntaTab && (
            <motion.div
              key="tab-pregunta"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
            >
              <TabPorPregunta
                preguntaRespuestaAgrupada={summary.pregunta_respuesta_agrupada}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Continuar al siguiente quiz — responsive */}
        <motion.div
          className="d-flex justify-content-center mt-4 mb-3 px-3"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.4 }}
        >
          <button
            type="button"
            onClick={() => navigate("/fortalezas-quiz")}
            className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm w-100 w-sm-auto"
            style={{
              maxWidth: 420,
              minHeight: 44,
              padding: "0.65rem 1.5rem",
              fontSize: "clamp(0.85rem, 2.4vw, 1rem)",
              lineHeight: 1.25,
              textAlign: "center",
            }}
          >
            <Icon icon="mdi:arrow-right-circle" width="20" />
            Sigamos construyendo tus 7 fortalezas
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default ConfirmacionSummary;
